<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        v-on:add="openAddSlider"
        v-on:searchByParameter="searchByParameter"
        v-on:bulkUpload="bulkUpload"
        v-on:getExcel="getExcel"
        @rejectDownload="rejectDownload"
        @exportData="exportData"
        searchText="Search" />
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft"
        >
        </FilterWrapper>
      </div>
    </div>
    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div
        class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10"
      >
        <MdmHeader
          :headers="sectionHeaders"
          :maxDisplayColumn="6"
          :hasColumnPicker="true"
          :noCheckbox="true"/>
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">{{$t('MDM_NO_DATA_FOUND')}}</div>
        </div>
        <MdmRow
          v-else
          v-for="(transshipment,index) in transshipmentList"
          :key="index"
          :data="transshipment"
          :headers="sectionHeaders"
          :showEdit="showEdit"
          v-on:edit="openEditForm(transshipment)"
        />
      </div>
      <div class="slideleft_menu">
        <SecFilter
          v-if="!isLoading"
          :selectedFilters="filterConstant"
          :filters="filters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply" />
      </div>
    </div>
    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-20" v-if="showForm">
          <Drawer
            :visible.sync="showForm"
            direction="rtl"
            size="500px"
            :modal="true"
            :withHeader="false"
            :wrapperClosable="false"
            :append-to-body="true"
            class="default-drawer"
          >
            <Link :underline="false" class="nav-close" @click="resetFormOptions">
              <svgicon
                name="cancelwhite"
                width="12"
                height="12"
                :original="true"
              />
            </Link>
            <Form
              :formConstant="transshipmentFormConstants"
              :data="selectedRow"
              :isEdit="isEditForm"
              sectionTitle="Transshipment master"
              @cancel="closeSlider"
              @add="add"
              @update="update"
              @setGateOptions="setGateOptions"
              @resetFormOptions="resetFormOptions"
            >
            </Form>
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from './Row';
import Form from './Form';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { filters, hubType, statusList } from '@/constants/mdm-v2/transshipmentConstants';
import { hubTypeList } from '@common/constants/mdm';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import SecFilter from '@common/components/SecFilter';
import { mapGetters, mapState } from 'vuex';
import { flatMap, map } from 'lodash';

export default {
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
    Form,
    FilterWrapper,
    SecFilter,
  },

  mixins: [SharedMdm, SecFilterMixin],
  data() {
    return {
      skipEditPermission: true,
      overrideDefaultSearchParms: true,
      filterConstant: [],
      rolesList: [],
      openSlideleft: false,
      defaultValues: {},
      filters,
      statusList,
      hubType,
      hubTypeList,
    };
  },
  async created() {
    this.setDefaults();
    this.loadSearchFromSession();
    this.loadFilterFromSession();
    this.loadMore();
  },
  computed: {
    ...mapState('mdmV2', [
      'isLoading',
      'all',
      'isUploading',
    ]),
    ...mapGetters({
      depots: 'app/depots',
    }),
    transshipmentList() {
      const data = this.list.reduce((_data, transshipment) => {
        if (transshipment.id && !_data[transshipment.id]) {
          const newObj = {};
          const hubTypeConstant = this.hubTypeList.find(
            type => type.id === Number(transshipment.hubType));
          newObj.hubType = (hubTypeConstant && hubTypeConstant.name) || '';
          const transshipmentStatus = this.statusList && this.statusList.find(type => type.id === transshipment.status);
          newObj.status = transshipmentStatus ? transshipmentStatus.name : '';
          newObj.hub = transshipment.hubList ? transshipment.hubList.reduce((res, _hub) => {
            if (_hub && _hub.refId) {
              res.refId.push(_hub.refId);
            }
            if (_hub && _hub.depotName) {
              res.depotName.push(_hub.depotName);
            }
            return res;
          }, { depotName: [], refId: [] }) : {};
          _data[transshipment.id] = { ...transshipment, ...newObj };
        }
        return _data;
      }, {});
      return Object.values(data);
    },
    transshipmentFormConstants() {
      return this.addFormConstants.map((formConstant) => {
        if (formConstant.paramKey === 'depots') {
          formConstant.options = this.depots.filter(depot => depot.delivery_type === 1);
        }
        if (formConstant.paramKey === 'hubRefsList') {
          const depots = this.depots.filter(depot => depot.delivery_type === 4);
          formConstant.options = flatMap(depots, ({ _id, gates }) =>
            map(gates, _gate => ({ _id, ..._gate })));
        }
        return formConstant;
      });
    },
  },

  methods: {
    resetFormOptions() {
      this.addFormConstants.forEach((ele) => {
        if (ele.paramKey === 'sourceRefId') {
          ele.options = [];
        }
        this.closeSlider();
      });
    },
    searchApply() {
      this.applyFilters();
      this.openSlideleft = false;
      const filter = this.constructFilterPayload();
      this.searchByFilter(filter);
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    setDefaults() {
      [this.defaultValues.status] = this.statusList;
      [this.defaultValues.hubType] = this.hubType;
    },
    loadFilterFromSession() {
      this.loadFilters();
      this.applyFilters();
      this.filterParams = this.constructFilterPayload();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON = localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    constructAddTransshipmentPayload(_data) {
      const data = _data;
      data.hubType = data.hubType === 'Transporter Hub' ? 1 : data.hubType;
      if (data.status === 'Active' || data.status === 1) {
        data.status = 1;
      } else {
        data.status = 2;
      }
      delete data.depots;
      return data;
    },
    constructUpdateTransshipmentPayload(_data) {
      const data = _data;
      data.hubType = data.hubType === 'Transporter Hub' ? 1 : data.hubType;
      if (data.status === 'Active' || data.status === 1) {
        data.status = 1;
      } else {
        data.status = 2;
      }
      delete data.depots;
      return data;
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'List',
            category: this.filters.STATUS,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.statusList,
            idLabel: 'id',
            queryParamString: 'status',
            optional: true,
          },
          {
            type: 'List',
            category: this.filters.HUB_TYPE,
            default: this.defaultValues.hubType,
            selected: this.defaultValues.hubType,
            list: this.hubType,
            idLabel: 'id',
            queryParamString: 'hubType',
            optional: true,
          },
        ],
      ];
    },
    async openEditForm(data) {
      const userData = await this.$store.dispatch('mdmV2/show', {
        section: this.currentSection,
        id: data.id,
      });
      const newData = {
        id: data.id,
        depots: userData.source.depotName,
        sourceRefId: userData.source.refId,
        sourceDepotId: userData.source.id,
        hubRefsList: userData.hubList.map(_hub => _hub.gateName).toString(),
        hubIds: userData.hubList.map(_hub => _hub.id),
        hubRef: userData.hubList.map(_hub => ({
          name: _hub.gateName,
          id: _hub.id,
          ref_name: `${_hub.gateName}-${_hub.refId}`,
        })),
        hubType: this.hubTypeList.find(type => type.id === userData.hubType).name,
        status: this.statusList.find(type => type.id === userData.status).name,
      };
      this.selectedRow = newData;
      const depots = this.selectedRow.depots;
      this.selectedRow.depots = {
        id: depots,
        name: depots,
        depots,
      };
      const hubRefsList = this.selectedRow.hubRefsList;
      const hubId = this.selectedRow.hubIds;
      this.selectedRow.hubRefsList = {
        hubId,
        name: hubRefsList,
        hubRefsList,
        hubRef: newData.hubRef,
      };
      const sourceRefId = this.selectedRow.sourceRefId;
      this.selectedRow.sourceRefId = {
        id: newData.sourceDepotId,
        name: sourceRefId,
        sourceRefId,
      };
      const hubTypeForm = this.selectedRow.hubType;
      this.selectedRow.hubType = {
        id: hubTypeForm,
        name: hubTypeForm,
        hubTypeForm,
      };
      const status = this.selectedRow.status;
      this.selectedRow.status = {
        id: status,
        name: status,
        status,
      };
      this.setGateOptions(userData.source.depotId);
      this.selectedRow = Object.assign({}, this.selectedRow);
      this.isEditForm = true;
      this.openSlider();
    },
    async setGateOptions(data) {
      const gates = await this.$store.dispatch('depot/gates',
        {
          depotId: data,
        });
      this.addFormConstants.forEach((formConstant) => {
        if (formConstant.paramKey === 'sourceRefId') {
          formConstant.options = gates;
        }
      });
    },
  },
};
</script>
